import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import { last } from "lodash";
export default {
  namespaced: true,
  state: {
    isLoading: false,
    list: [],
    listOrigin: [],
    searchField: "code",
    page: 1,
    count: 0,
    keyword: "",
    fromDate: "",
    toDate: "",
    filterCondition: "",
    emptyList: true,
    stackPage: {},
    currentPageAlgolia: 0,
    assetList: [],
    assetCounts: [],
    departments: [],
    locations: [],
    assetClasses: [],
    orderBySelect: { key: "assetCode", value: "desc" },
    selectedList: [],
    filterData: {
      departmentID: "",
      locationID: "",
      classID: "",
      fromDate: "",
      toDate: "",
    },
    showPaginationTemplate: true,
    unsubscribeObjects: {
      assetListUnsubscribe: null,
      assetsCountUnsubscribe: null,
      departmentsUnsubscribe: null,
      locationsUnsubscribe: null,
      classesUnsubscribe: null
    }
  },
  
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload;
    },
    setAssetList(state, payload) {
      state.assetList = payload;
    },
    setAssetCounts(state, payload) {
      state.assetCounts = payload;
    },
    setDepartments(state, payload) {
      state.departments = payload;
    },
    setLocations(state, payload) {
      state.locations = payload;
    },
    setAssetClasses(state, payload) {
      state.assetClasses = payload;
    },
    setFilterData(state, payload) {
      state.filterData = { ...state.filterData, ...payload };
    },
    
    setKeyword(state, payload) {
      state.keyword = payload;
    },
    resetKeyword(state) {
      state.keyword = "";
    },
    setSelectedList(state, { selectedList }) {
      state.selectedList = selectedList;
    },    setUnsubscribeObject(state, { type, unsubscribe }) {
      state.unsubscribeObjects[type] = unsubscribe;
    },    setOrderBySelect(state, { orderBySelect }) { 
      // Validate the orderBySelect object before setting it
      if (orderBySelect && typeof orderBySelect === 'object') {
        state.orderBySelect = orderBySelect;
      } else {
        // Fallback to default if invalid data is passed
        state.orderBySelect = { key: "assetCode", value: "desc" };
      }
    },
    
  },
  
  actions: {    async fetchAssetList({ commit, state }, { companyId }) {
      commit("setLoading", true);
      
      try {
        // Unsubscribe from previous listeners if they exist
        if (state.unsubscribeObjects.assetListUnsubscribe) {
          state.unsubscribeObjects.assetListUnsubscribe();
        }
        
        console.log("Fetching asset list for company:", companyId);
        if (!companyId) {
          console.error("Company ID is required to fetch asset list.");
          commit("setLoading", false);
          return;
        }
        
        let query = fc.companies.doc(companyId).collection("DocsFixedAsset");
        console.log("Base query created for company ID:", companyId); 
        
        // Order by selected field
        if(state.orderBySelect && state.orderBySelect.key && state.orderBySelect.value) {
          console.log("Applying orderBy:", state.orderBySelect.key, state.orderBySelect.value);
          query = query.orderBy(state.orderBySelect.key, state.orderBySelect.value);
        } else {
          // Default ordering if no orderBySelect is set
          console.log("Applying default orderBy: assetCode desc");
          query = query.orderBy('assetCode', 'desc');
        }
        
        console.log("Final query configuration applied");
        
        // Set up real-time listener
        const unsubscribe = query.onSnapshot((snapshot) => {   
            console.log("Asset list snapshot received, documents count:", snapshot.size);
            const assets = snapshot.docs.map((doc, index) => {
            const data = doc.data();
            return {
              no: index + 1,
              id: doc.id,
              assetCode: data.assetCode || "",
              assetName: data.assetName || "",
              assetDepartment: data.assetDepartment || "",
              assetClass: data.assetClass || "",
              assetLocation: data.assetLocation || "",
              lastCountDate: data.lastCountDate || "",
              countStatus: data.countStatus || "",
              imageUrl: data.imageUrl || "",
            };
          });
          
          console.log("Processed assets for display:", assets.length);
          commit("setAssetList", assets);
          commit("setLoading", false);
        }, error => {
          console.error("Error fetching fixed assets:", error);
          commit("setLoading", false);
        });
        
        // Store the unsubscribe function
        commit("setUnsubscribeObject", { 
          type: "assetListUnsubscribe", 
          unsubscribe 
        });
        
      } catch (error) {
        console.error("Error setting up asset list listener:", error);
        commit("setLoading", false);
      }
    },
    async fetchAssetCount({commit, state}, { companyId, departmentId = null, locationId = null }) {
      try {
          commit("setLoading", true);

          if (!companyId) {
            console.error("Company ID is required to fetch assets count.");
            commit("setLoading", false);
            return { count: 0 };
          }

          // Unsubscribe from previous listeners if they exist
          if (state.unsubscribeObjects.assetsCountUnsubscribe) {
            state.unsubscribeObjects.assetsCountUnsubscribe();
          }

          // Build the query
          let query = fc.companies.doc(companyId).collection("FixedAssetsCount");

          // Apply filters if provided
          if (departmentId) {
            console.log("Filtering by department ID:", departmentId);
            query = query.where("departmentID", "==", departmentId);
          }
          
          if (locationId) {
            console.log("Filtering by location ID:", locationId);
            query = query.where("locationID", "==", locationId);
          }

          // Set up real-time listener for count
          const unsubscribe = query.onSnapshot((snapshot) => {
            const count = snapshot.size;
            console.log(`Assets count for company ${companyId}:`, count);
            
            const assetsCount = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));
            console.log("Assets count data:", assetsCount); 
            commit("setAssetCounts", assetsCount);
            
            commit("setLoading", false); 
          }, error => {
            console.error("Error fetching assets count:", error);
            commit("setLoading", false);
            return { count: 0, error: error.message };
          });

          // Store the unsubscribe function
          commit("setUnsubscribeObject", { 
            type: "assetsCountUnsubscribe", 
            unsubscribe 
          });

          // For immediate count without waiting for snapshot
          const snapshot = await query.get();
          const immediateCount = snapshot.size;
          
          commit("setLoading", false);
          return { count: immediateCount };

      }
      catch (error) {
        console.error("Error fetching assets count:", error);
        commit("setLoading", false);
        return { count: 0, error: error.message };
      }
    },

    async fetchDepartments({ commit, state }, { companyId }) {
      try {
        if (state.unsubscribeObjects.departmentsUnsubscribe) {
          state.unsubscribeObjects.departmentsUnsubscribe();
        }
        
        const unsubscribe = fc.companies
          .doc(companyId)
          .collection("FixedAssetDepartment")
          .onSnapshot(snapshot => {
            const departments = snapshot.docs.map(doc => ({
              id: doc.id,
              name: doc.data().name || ""
            }));
            
            commit("setDepartments", departments);
          });
        
          
        commit("setUnsubscribeObject", { 
          type: "departmentsUnsubscribe", 
          unsubscribe 
        });
        
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    },
    
    async fetchLocations({ commit, state }, { companyId }) {
      try {
        if (state.unsubscribeObjects.locationsUnsubscribe) {
          state.unsubscribeObjects.locationsUnsubscribe();
        }
        
        const unsubscribe = fc.companies
          .doc(companyId)
          .collection("FixedAssetLocation")
          .onSnapshot(snapshot => {
            const locations = snapshot.docs.map(doc => ({
              id: doc.id,
              name: doc.data().name || ""
            }));
            
            commit("setLocations", locations);
          });
        
        commit("setUnsubscribeObject", { 
            type: "locationsUnsubscribe", 
            unsubscribe 
          });
        // const locations = [
        //   { id: "1", name: "Head Office" },
        //   { id: "2", name: "Branch Office" },
        //   { id: "3", name: "Warehouse" },
        //   { id: "4", name: "Remote Site" }
        // ]
        //   commit("setLocations", locations);
        
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    },
    
    async fetchAssetClasses({ commit, state }, { companyId }) {
      try {
        if (state.unsubscribeObjects.classesUnsubscribe) {
          state.unsubscribeObjects.classesUnsubscribe();
        }
        
        const unsubscribe = fc.companies
          .doc(companyId)
          .collection("AssetClasses")
          .onSnapshot(snapshot => {
            const assetClasses = snapshot.docs.map(doc => ({
              id: doc.id,
              name: doc.data().name || ""
            }));
            
            commit("setAssetClasses", assetClasses);
          });
          
        commit("setUnsubscribeObject", { 
          type: "classesUnsubscribe", 
          unsubscribe 
        });
        
      } catch (error) {
        console.error("Error fetching asset classes:", error);
      }
    },
    
    async addNewAsset({ commit, dispatch }, { companyId, assetData }) {
      try {
        commit("setLoading", true);
          // Generate a unique code if not provided
        if (!assetData.assetCode) {
          // Get current count of assets to generate a sequential code
          const countQuery = await fc.companies
            .doc(companyId)
            .collection("DocsFixedAsset")
            .get();
            
          const count = countQuery.size + 1;
          assetData.assetCode = `FAM${String(count).padStart(6, '0')}`;
        }
        
        // Add timestamp
        assetData.createdAt = fc.firebase.firestore.FieldValue.serverTimestamp();
        assetData.updatedAt = fc.firebase.firestore.FieldValue.serverTimestamp();
          // Add to Firestore
        await fc.companies
          .doc(companyId)
          .collection("DocsFixedAsset")
          .add(assetData);
        
        commit("setLoading", false);
        return { success: true };
      } catch (error) {
        console.error("Error adding new asset:", error);
        commit("setLoading", false);
        return { success: false, error: error.message };
      }
    },
    
    async updateAsset({ commit }, { companyId, assetId, assetData }) {
      try {
        commit("setLoading", true);
        
        // Add update timestamp
        assetData.updatedAt = fc.firebase.firestore.FieldValue.serverTimestamp();
          // Update in Firestore
        await fc.companies
          .doc(companyId)
          .collection("DocsFixedAsset")
          .doc(assetId)
          .update(assetData);
        
        commit("setLoading", false);
        return { success: true };
      } catch (error) {
        console.error("Error updating asset:", error);
        commit("setLoading", false);
        return { success: false, error: error.message };
      }
    },
    
    async deleteAsset({ commit }, { companyId, assetId }) {
      try {
        commit("setLoading", true);
          // Delete from Firestore
        await fc.companies
          .doc(companyId)
          .collection("DocsFixedAsset")
          .doc(assetId)
          .delete();
        
        commit("setLoading", false);
        return { success: true };
      } catch (error) {
        console.error("Error deleting asset:", error);
        commit("setLoading", false);
        return { success: false, error: error.message };
      }
    },
    
    setFilterData({ commit }, data) {
      commit("setFilterData", data);
    },
    
    setKeyword({ commit }, keyword) {
      commit("setKeyword", keyword);
    },
    
    resetKeyword({ commit }) {
      commit("resetKeyword");
    },
    
    setSelectedList({ commit }, selectedList) {
      commit("setSelectedList", { selectedList });
    },
    
    clearAllListeners({ state }) {
      // Cleanup all listeners when component unmounts
      Object.values(state.unsubscribeObjects).forEach(unsubscribe => {
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      });
    },    setOrderBySelect({ commit }, { orderBySelect }) { 
      console.log("Setting orderBySelect:", orderBySelect);
      
      // Validate the orderBySelect object
      if (!orderBySelect || typeof orderBySelect !== 'object') {
        console.warn("Invalid orderBySelect object, using default");
        orderBySelect = { key: "assetCode", value: "desc" };
      }
      
      if (!orderBySelect.key || !orderBySelect.value) {
        console.warn("Missing key or value in orderBySelect, using default");
        orderBySelect = { key: "assetCode", value: "desc" };
      }
      
      if (!['asc', 'desc'].includes(orderBySelect.value)) {
        console.warn("Invalid orderBySelect value, defaulting to desc");
        orderBySelect.value = 'desc';
      }
      
      commit("setOrderBySelect", { orderBySelect });
      console.log("OrderBySelect successfully updated to:", orderBySelect);
    },
    async setFixedAssetsCountByLocation({ commit, state }, { companyId, locationId,locationName,date, description = '' }) {
      try {
        commit("setLoading", true);

        if (!companyId || !locationId || !date) {
          throw new Error('Company ID, Location ID, and Date are required');
        }

        // Validate date format and convert to start and end of day
        const countDate = new Date(date);
        if (isNaN(countDate.getTime())) {
          throw new Error('Invalid date format');
        }

        const startOfDay = new Date(countDate);
        startOfDay.setHours(0, 0, 0, 0);
        
        const endOfDay = new Date(countDate);
        endOfDay.setHours(23, 59, 59, 999);

        // Check if there's already a count session for this location on this date
        const existingCountQuery = fc.companies
          .doc(companyId)
          .collection("FixedAssetsCount")
          .where("locationID", "==", locationId)
          .where("createdAt", ">=", firebase.firestore.Timestamp.fromDate(startOfDay))
          .where("createdAt", "<=", firebase.firestore.Timestamp.fromDate(endOfDay));

        const existingCountSnapshot = await existingCountQuery.get();
        
        if (!existingCountSnapshot.empty) {
          const existingSession = existingCountSnapshot.docs[0].data();
          throw new Error(`A counting session already exists for location "${locationName}" on ${date}. Session ID: ${existingSession.id}`);
        }

        // Get all assets for the specified location
        let assetQuery = fc.companies
          .doc(companyId)
          .collection("DocsFixedAsset")
          .where("assetLocationID", "==", locationId);

        const assetSnapshot = await assetQuery.get();
        const assetsInLocation = [];
        
        assetSnapshot.forEach(doc => {
          const data = doc.data();
          assetsInLocation.push({
            id: doc.id,
            assetCode: data.assetCode || "",
            assetName: data.assetName || "",
            assetDepartment: data.assetDepartment || "",
            assetDepartmentID: data.assetDepartmentID || "",
            assetLocation: data.assetLocation || "",
            assetLocationID: data.assetLocationID || "",
            assetClass: data.assetClass || "",
            assetClassID: firebase.firestore.Timestamp.fromDate(new Date(date)) || '',
            
          });
        });

        const totalAssets = assetsInLocation.length;

        if (totalAssets === 0) {
          throw new Error('No assets found in the specified location');
        }

        // Create FixedAssetsCount document
        const countDocRef = fc.companies
          .doc(companyId)
          .collection("FixedAssetsCount")
          .doc(); 

        const countData = {
          id: countDocRef.id,
          locationID: locationId, 
          locationName: locationName, 
          assetsTotal: totalAssets,
          assetsCount: 0, // Initial count 
          description: description,
          status: "Inprogress",
          countBy:null,
          createdAt: firebase.firestore.Timestamp.fromDate(new Date(date)),
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        };

        // Save the count document
        await countDocRef.set(countData, { merge: true });
        // Create assetsList subcollection with all assets from the location
        const batch = fc.db.batch();
        const batchUpdate = fc.db.batch();
        console.log("Assets in location:", assetsInLocation);
        assetsInLocation.forEach(asset => {
          const assetRef = countDocRef.collection("assetsList").doc(asset.id);
          const assetListRef = fc.companies.doc(companyId).collection("DocsFixedAsset").doc(asset.id);
          batch.set(assetRef, {
            ...asset,
            lastCountDate: firebase.firestore.Timestamp.fromDate(new Date(date)),
            countedAt: null,
            countStatus: "Uncounted", // Default status for counting
            notes: ""
          }, { merge: true }); 
         batchUpdate.set(assetListRef, { 
            lastCountDate: firebase.firestore.Timestamp.fromDate(new Date(date)),
            countedAt: null,
            countStatus: "Uncounted", // Default status for counting
            notes: ""
          }, { merge: true });

        });
        await batch.commit(); 
        await batchUpdate.commit();
        // assetsInLocation.forEach(asset => { 
        //   const assetListRef = assetListDocRef.doc(asset.id); 
        //  batchUpdate.set(assetListRef, { 
        //     lastCountDate: firebase.firestore.Timestamp.fromDate(new Date(date)),
        //     countedAt: null,
        //     countStatus: "Uncounted", // Default status for counting
        //     notes: ""
        //   }, { merge: true });

        // });
        // await batchUpdate.commit();

        console.log(`Created FixedAssetsCount with ${totalAssets} assets for location ${locationId}`);

        commit("setLoading", false);
        
        return {
          success: true,
          countId: countDocRef.id,
          totalAssets: totalAssets,
          assetsInLocation: assetsInLocation
        };

      } catch (error) {
        console.error("Error setting FixedAssetsCount by location:", error);
        commit("setLoading", false);
        return { success: false, error: error.message };
      }
    },
    //fetch assets list by count ID
    async fetchAssetsListByCountId({ commit }, { companyId, countId }) {
      try {
        commit("setLoading", true);

        if (!companyId || !countId) {
          throw new Error('Company ID and Count ID are required');
        }

        const assetsRef = fc.companies
          .doc(companyId)
          .collection("FixedAssetsCount")
          .doc(countId)
          .collection("assetsList");

        const snapshot = await assetsRef.get();
        const assetsList = [];

        snapshot.forEach(doc => {
          assetsList.push({
            id: doc.id,
            ...doc.data()
          });
        });

        commit("setAssetList", assetsList);
        commit("setLoading", false);

        return {
          success: true,
          assetsList: assetsList,
          count: assetsList.length
        };

      } catch (error) {
        console.error("Error fetching assets list by count ID:", error);
        commit("setLoading", false);
        return { success: false, error: error.message };
      }
    },
//not used
    async updateAssetCountStatus({ commit }, { companyId, countId, assetId, status, notes = '' }) {
      try {
        if (!companyId || !countId || !assetId || !status) {
          throw new Error('Company ID, Count ID, Asset ID, and Status are required');
        }

        const assetRef = fc.companies
          .doc(companyId)
          .collection("FixedAssetsCount")
          .doc(countId)
          .collection("assetsList")
          .doc(assetId);

        const updateData = {
          countStatus: status,
          notes: notes,
          countedAt: fc.firebase.firestore.FieldValue.serverTimestamp(),
          updatedAt: fc.firebase.firestore.FieldValue.serverTimestamp()
        };

        await assetRef.update(updateData);

        // Update the main count document
        await this.dispatch('fixedAssets/updateFixedAssetsCountSummary', {
          companyId,
          countId
        });

        return { success: true };

      } catch (error) {
        console.error("Error updating asset count status:", error);
        return { success: false, error: error.message };
      }
    },
//not used
    async updateFixedAssetsCountSummary({ commit }, { companyId, countId }) {
      try {
        // Get all assets in the count
        const assetsRef = fc.companies
          .doc(companyId)
          .collection("FixedAssetsCount")
          .doc(countId)
          .collection("assetsList");

        const snapshot = await assetsRef.get();
        let countedAssets = 0;
        let totalAssets = snapshot.size;

        snapshot.forEach(doc => {
          const data = doc.data();
          if (data.countStatus === 'counted' || data.countStatus === 'found') {
            countedAssets++;
          }
        });

        // Update the main count document
        const countRef = fc.companies
          .doc(companyId)
          .collection("FixedAssetsCount")
          .doc(countId);

        await countRef.update({
          assetsCount: countedAssets,
          assetsTotal: totalAssets,
          updatedAt: fc.firebase.firestore.FieldValue.serverTimestamp(),
          status: countedAssets === totalAssets ? 'completed' : 'inprogress'
        });

        return { success: true, countedAssets, totalAssets };

      } catch (error) {
        console.error("Error updating FixedAssetsCount summary:", error);
        return { success: false, error: error.message };
      }
    },


  },
  
  getters: {
    getFilteredAssets: (state) => {
      if (!state.keyword) {
        return state.assetList;
      }
      
      const searchTerm = state.keyword.toLowerCase();
      return state.assetList.filter(asset => 
        asset.name.toLowerCase().includes(searchTerm) || 
        asset.code.toLowerCase().includes(searchTerm) || 
        asset.department.toLowerCase().includes(searchTerm) ||
        asset.class.toLowerCase().includes(searchTerm) ||
        asset.location.toLowerCase().includes(searchTerm)
      );
    },
    
    getDepartmentById: (state) => (id) => {
      const dept = state.departments.find(dep => dep.id === id);
      return dept ? dept.name : '';
    },
    
    getLocationById: (state) => (id) => {
      const loc = state.locations.find(loc => loc.id === id);
      return loc ? loc.name : '';
    },
    
    getClassById: (state) => (id) => {
      const cls = state.assetClasses.find(cls => cls.id === id);
      return cls ? cls.name : '';
    }
  }
};